<script lang="ts" setup>
import type { SwiperOptions } from 'swiper/types';

defineProps({
	swiperOptions: {
		type: Object as PropType<SwiperOptions>,
		default: () => ({}),
	},
	modules: {
		type: Array as PropType<any[]>,
		default: () => [],
	},
});

defineEmits<{
	(e: 'onFromEdge'): void;
	(e: 'onToEdge'): void;
	(e: 'onSlideNext'): void;
	(e: 'onSlidePrev'): void;
	(e: 'onReachBeginning'): void;
	(e: 'onReachEnd'): void;
}>();

const swiperRef = ref<{ $el: HTMLElement; $swiper: any } | null>(null);
const swiperInstance = ref<any>(null);

const onSwiper = (swiper: any) => {
	swiperInstance.value = swiper;
};

const handleSlideNext = () => {
	if (swiperInstance.value) {
		swiperInstance.value.slideNext();
	} else if (swiperRef.value?.$swiper) {
		swiperInstance.value = swiperRef.value.$swiper;
		swiperInstance.value.slideNext();
	}
};

const handleSlidePrev = () => {
	if (swiperInstance.value) {
		swiperInstance.value.slidePrev();
	} else if (swiperRef.value?.$swiper) {
		swiperInstance.value = swiperRef.value.$swiper;
		swiperInstance.value.slidePrev();
	}
};

defineExpose({
	handleSlideNext,
	handleSlidePrev,
});
</script>

<template>
	<Swiper
		ref="swiperRef"
		:modules="modules"
		v-bind="swiperOptions"
		class="base-carousel"
		@from-edge="$emit('onFromEdge')"
		@to-edge="$emit('onToEdge')"
		@reach-beginning="$emit('onReachBeginning')"
		@reach-end="$emit('onReachEnd')"
		@slide-next-transition-end="$emit('onSlideNext')"
		@slide-prev-transition-end="$emit('onSlidePrev')"
		@swiper="onSwiper"
	>
		<slot />
	</Swiper>
</template>

<style lang="scss" scoped>
.base-carousel {
	width: 100%;
	height: 100%;
}
</style>
